module.exports = __webpack_public_path__ + "media/images/application/template/arrow-up-62ddb8cf696b9ff7f910553abb27cc49.svg";